import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="#EDF2F5"
      d="M.504 5.125V1a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 .75.75v4.125a1.875 1.875 0 0 0 0 3.75V13a.75.75 0 0 1-.75.75h-13.5a.75.75 0 0 1-.75-.75V8.875a1.875 1.875 0 0 0 0-3.75Zm9-3.375h-7.5v2.226a3.375 3.375 0 0 1 0 6.048v2.226h7.5V1.75Zm1.5 0v10.5h3v-2.226a3.375 3.375 0 0 1 0-6.048V1.75h-3Z"
    />
  </svg>
);
export default SVGComponent;
